/**
 * Initializes one offers carousel.
 * @param {HTMLElement} section
 */
function initializeOffersCarousel(section) {
  if (section.dataset.initialized === 'true') return;

  const swiperElement = section.querySelector('[data-offers-carousel-swiper]');
  if (!(swiperElement instanceof HTMLElement) || typeof window.Swiper !== 'function') return;

  section.dataset.initialized = 'true';
  section.offersCarouselSwiper = new window.Swiper(swiperElement, {
    slidesPerView: 2.3,
    spaceBetween: 10,
    loop: section.dataset.loop === 'true',
    watchOverflow: true,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    a11y: {
      enabled: true,
    },
    navigation: {
      nextEl: section.querySelector('[data-offers-carousel-next]'),
      prevEl: section.querySelector('[data-offers-carousel-prev]'),
    },
    breakpoints: {
      750: {
        slidesPerView: 3,
      },
      994: {
        slidesPerView: 6,
      },
    },
  });
}

function initializeOffersCarousels(scope = document) {
  scope.querySelectorAll('[data-offers-carousel]').forEach((section) => {
    if (section instanceof HTMLElement) initializeOffersCarousel(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeOffersCarousels(), { once: true });
} else {
  initializeOffersCarousels();
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) initializeOffersCarousels(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target instanceof Element ? event.target.querySelector('[data-offers-carousel]') : null;
  section?.offersCarouselSwiper?.destroy(true, true);
});
